export const FETCHING_CUSTOMERS = "fetchingCustomers";
export const REGISTER_CUSTOMER = "RegisterCustomer";
